const LCN = (state = [], action) => {

	let LCN;

	switch (action.type) {

		case 'PUT_LCN':

			LCN = action.payload.lcn;

			return { ...LCN };

		case 'CLEAR_LCN':

			LCN = {};

			return { ...LCN };

		default:

			return state;
	}
}

export default LCN;



// WEBPACK FOOTER //
// ./src/reducers/lcn.js